import React from "react";
import { useI18n } from "@/i18n/I18nProvider";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQ = () => {
  const { t } = useI18n();
  return (
    <section id="faq" className="py-20 md:py-32 bg-white" data-testid="faq-section">
      <div className="zdc-container">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <div className="md:sticky md:top-28">
              <div className="text-xs font-medium uppercase tracking-[0.18em] text-[#2563EB] mb-3">{t.faq.eyebrow}</div>
              <h2 className="font-display text-3xl md:text-4xl font-semibold tracking-tight text-[#111111]">
                {t.faq.title}
              </h2>
              <p className="mt-4 text-base text-[#6B7280]">{t.faq.subtitle}</p>
            </div>
          </div>
          <div className="md:col-span-8">
            <Accordion type="single" collapsible className="space-y-2.5">
              {t.faq.items.map((it, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="border border-[#E5E7EB] rounded-2xl px-5 md:px-6 bg-white hover:border-[#111111]/20 transition-colors data-[state=open]:border-[#2563EB]/40 data-[state=open]:bg-[#F5F7FA]"
                  data-testid="faq-item"
                >
                  <AccordionTrigger className="text-left hover:no-underline py-5 font-display text-base md:text-lg font-medium text-[#111111]">
                    {it.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-sm md:text-base text-[#6B7280] leading-relaxed pb-5 pr-4">
                    {it.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
